import { render, staticRenderFns } from "./CompactMulti.vue?vue&type=template&id=05241773&"
import script from "./CompactMulti.vue?vue&type=script&lang=ts&"
export * from "./CompactMulti.vue?vue&type=script&lang=ts&"
import style0 from "./CompactMulti.vue?vue&type=style&index=0&id=05241773&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports